import { createRef, useEffect, useLayoutEffect, useRef, useState } from "react"
import * as mb from "../../../common/MessageBox";
import { InputCounter } from "views/guest/common/InputCounter";
import { getCart, removeCart, setCart } from "views/utils/CartFunc";
import { IFCart, IFService } from "views/utils/CommonConst";
import { numberToPrice, priceToNumber, scrollTop, sendWindowHeight } from "views/utils/CommonFunc";
import { getRef } from "views/utils/InputHelp";
import { useHistory } from "react-router-dom";
import { getApiData } from "views/utils/CallApi";
import { AxiosResponse } from "axios";
import { Error } from "views/guest/pages/error/Error";

export function Cart(): JSX.Element {

    const [msgArgs, setMsgArgs] = useState({type:"", text:""});
    const [services, setServices] = useState<IFService[]>([]);
    const [sumPrice, setSumPrice] = useState("");
    const [bdServiceSum, setBdServiceSum] = useState(0);
    const [bdOptionSum, setBdOptionSum] = useState(0);
    const history = useHistory();
    const [loadErr, setLoadErr] = useState("");
    const refWindow = useRef<HTMLDivElement>(null);

    useEffect(function(){

        scrollTop();

        //セッションからカート情報を取得
        let tmpCart:IFCart[] = getCart();
        let tmpServices:IFService[] = [];
        tmpCart.forEach(function(service){
            let tmpOptions:any = [];
            service.option_list.forEach(function(option){
                tmpOptions.push({
                    option_id: option.option_id,
                    option_name: option.option_name,
                    option_explanation: option.option_explanation,
                    option_price: option.option_price,
                    option_image: option.option_image,
                    option_count: option.option_count,
                    option_counter: createRef(),
                });
            });
            tmpServices.push({
                service_id: service.service_id,
                service_name: service.service_name,
                service_price: service.service_price,
                service_image: service.service_image,
                service_explanation: service.service_explanation,
                service_url: service.service_url,
                service_unit: service.service_unit,
                service_count: service.service_count,
                service_counter: createRef(),
                option_list: tmpOptions,
            });
        });

        setServices(tmpServices);
        setBreakdownCount(tmpServices);

        //ウィンドウサイズを呼び出し元に渡す
        sendWindowHeight(refWindow);

    }, []);

    //画面リサイズでウィンドウサイズを呼び出し元に渡す
    useLayoutEffect(function(){
        window.addEventListener('resize', resize);
        return () => window.removeEventListener('resize', resize);
    });
    function resize(){
        sendWindowHeight(refWindow);
    }

    //serviceの情報に変更があった場合は、合計金額を再計算する
    useEffect(function(){
        let tmpSum = 0;
        services.forEach(function(service){
            tmpSum += priceToNumber(service.service_price) * service.service_count;
            service.option_list.forEach(function(option){
                tmpSum += priceToNumber(option.option_price) * option.option_count;
            });
        });
        setSumPrice(numberToPrice(tmpSum));
        setBreakdownCount(services);
    }, [services])

    //カウンターを制御するための処理
    function changeCounter(serviceIdx:number, optionIdx?:number){

        //画面表示設定
        let tmpServices:IFService[] = services.concat();
        //セッションカート情報設定
        let tmpCart:IFCart[] = getCart();

        if (optionIdx === undefined){
            //サービス数変更の場合
            let cnt = Number(getRef(services[serviceIdx].service_counter));
            tmpServices[serviceIdx].service_count = cnt;
            tmpCart[serviceIdx].service_count = cnt;
            tmpServices[serviceIdx].option_list.forEach(function(option){
                if (tmpServices[serviceIdx].service_count === 0){
                    option.option_count = 0;
                    tmpCart[serviceIdx].option_list.forEach(function(cart_option){
                        cart_option.option_count = 0;
                    });
                }
            });
        } else {
            //オプション数変更の場合
            let cnt = Number(getRef(services[serviceIdx].option_list[optionIdx].option_counter));
            tmpServices[serviceIdx].option_list[optionIdx].option_count = cnt;
            tmpCart[serviceIdx].option_list[optionIdx].option_count = cnt;
        }
        setServices(tmpServices);
        setBreakdownCount(tmpServices);
        setCart(tmpCart);

    }

    //内訳の数を更新する
    function setBreakdownCount(newServices:IFService[]){
        let svSum = 0;
        let opSum = 0;
        newServices.forEach(function(service){
            if (service.service_count > 0){
                svSum += 1;
            }
            service.option_list.forEach(function(option){
                if (option.option_count > 0){
                    opSum += 1;
                }
            });
        });
        setBdServiceSum(svSum);
        setBdOptionSum(opSum);
    }

    //カート削除処理
    function clickDelCart(serviceIdx:number, optionIdx?:number){
        let tmpServices:IFService[] = services.concat();
        if (optionIdx === undefined){
            removeCart(tmpServices[serviceIdx].service_id);
            tmpServices.splice(serviceIdx, 1);
        } else {
            removeCart(tmpServices[serviceIdx].option_list[optionIdx].option_id);
            tmpServices[serviceIdx].option_list.splice(optionIdx, 1);
        }
        setServices(tmpServices);
    }

    //申込へ進む処理
    function clickSubmit(){

        //商品が1点も選択されていない場合はエラー
        if (bdServiceSum === 0){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:"ご希望の商品を見積カートに入れてください。"});
            return;
        }

        //数量が100を超えていたらエラー（同一商品を何度もカートに入れることでできてしまう）
        let errFlg = false;
        for (let service of services){
            if (service.service_count > 100){
                setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:"サービスの数量は100以下にしてください。"});
                errFlg = true;
                break;
            }
            for (let option of service.option_list){
                if (option.option_count > 100){
                    setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:"オプションの数量は100以下にしてください。"});
                    errFlg = true;
                    break;
                }
            };
            if (errFlg){
                break;
            }
        };
        if (errFlg){
            return;
        }

        //ゲスト用トークンを取得する
        getApiData('/cart/token',
            {},
            function(res:AxiosResponse<any>){
                switch (res.status){
                    case 200:
                        sessionStorage.setItem('guest_access_exp', res.data.access_exp);
                        sessionStorage.setItem('guest_access_token', res.data.access_token);
                        //日時選択画面へ遷移
                        history.push("/guest/reservation");
                        break;
                    default:
                        setLoadErr("api_error");
                }
            }
        );
        
    }

    if (loadErr){
        return (
            <Error type={loadErr}/>
        )
    } else {
        return (
            <div className="order-main" ref={refWindow}>
                <div className="order-width-max">
                    <mb.MessageBox args={msgArgs}/>
                    <div className="order-flow">
                        <ul className="order-flow-list">
                            <li className="is-current">見積内容の確認</li>
                            <li>希望日時の選択</li>
                            <li>申込情報の入力</li>
                            <li>申込内容の確認</li>
                            <li>申込完了</li>
                        </ul>
                    </div>
                    <div className="order-form">
                        <div className="order-form-title">お見積り内容の確認</div>
                        <div className="order-form-sum">
                            <div>（内訳）サービス：{bdServiceSum}点 / オプション：{bdOptionSum}点</div>
                            <div className="order-form-sum-price">お見積り合計金額　<span className="text-size-ll text-weight-bold text-color-blue">{sumPrice}</span>（税込）</div>
                        </div>
                    </div>
                    <div className="form-row control-horizon control-between">
                        <button className="btn-order btn-secondary btn-icon-left" onClick={function(){window.location.href=process.env.PUBLIC_URL + "/guest/service"}}><span className="icon material-icons-round md-18">arrow_back</span>サービス・オプションを追加する</button>
                        <button className="btn-order btn-primary btn-icon-right" onClick={clickSubmit}>この見積内容で申込へ進む<span className="icon material-icons-round md-18">arrow_forward</span></button>
                    </div>
                    <div className="order-form">
                        <div className="order-form-title">お見積り内容の詳細</div>
                        <div className="text-color-red margin-t-10">お申込の前に、サービス・オプションの数量をご確認ください。</div>
                        {services.map(function(service, sv_idx){
                            return (
                                <div className="order-cart-item" key={sv_idx}>
                                    {service.service_image &&
                                    <div className="order-cart-item-img"><img src={service.service_image} alt={service.service_name} /></div>
                                    }
                                    <ul className={service.service_image ? "order-cart-item-list" : "order-cart-item-list no-img"}>
                                        <li className="service">
                                            <div className="order-cart-item-text">
                                                <div className="order-cart-item-title">
                                                    {service.service_url ? <a href={service.service_url}>{service.service_name}</a> : service.service_name}
                                                </div>
                                                <div className="order-cart-item-price">価格：<span className="text-weight-bold">{service.service_price}</span>(税込)</div>
                                            </div>
                                            <div className="order-cart-item-control">
                                                <div>
                                                    <div className="text-size-s">数量を変更する</div>
                                                    <div className="control-horizon control-vcenter margin-t-5">
                                                        <div className="order-item-control">
                                                            <InputCounter unit={service.service_unit} counterRef={service.service_counter} changeEvent={changeCounter} initCount={service.service_count} 
                                                                serviceIdx={sv_idx}></InputCounter>
                                                        </div>
                                                        <div className="text-nowrap"><span onClick={function(){clickDelCart(sv_idx)}} className="order-item-control-delete">削除</span></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                        {service.option_list.map(function(option, op_idx){
                                            return (
                                                <li className="option" key={op_idx}>
                                                    <div className="order-cart-item-text">
                                                        <div className="order-cart-item-title">{option.option_name}</div>
                                                        <div className="order-cart-item-price">価格：<span className="text-weight-bold">{option.option_price}</span>(税込)</div>
                                                    </div>
                                                    <div className="order-cart-item-control">
                                                        <div>
                                                            <div className="text-size-s">数量を変更する</div>
                                                            <div className="control-horizon control-vcenter margin-t-5">
                                                                <div className="order-item-control">
                                                                    <InputCounter counterRef={option.option_counter} changeEvent={changeCounter} 
                                                                        parentCounterRef={service.service_counter} initCount={option.option_count} 
                                                                        serviceIdx={sv_idx} optionIdx={op_idx}></InputCounter>
                                                                </div>
                                                                <div className="text-nowrap"><span onClick={function(){clickDelCart(sv_idx, op_idx)}} className="order-item-control-delete">削除</span></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </div>
                            )
                        })}
                        <div className="order-form-sum order-form-sum-detail">お見積り合計金額　<span className="text-size-ll text-weight-bold text-color-blue">{sumPrice}</span> （税込）</div>
                    </div>
                    <div className="form-row control-horizon control-between">
                        <button className="btn-order btn-secondary btn-icon-left" onClick={function(){window.location.href=process.env.PUBLIC_URL + "/guest/service"}}><span className="icon material-icons-round md-18">arrow_back</span>サービス・オプションを追加する</button>
                        <button className="btn-order btn-primary btn-icon-right js-next" onClick={clickSubmit}>この見積内容で申込へ進む<span className="icon material-icons-round md-18">arrow_forward</span></button>
                    </div>
                </div>
            </div>
        )
    }
}